import I18N from '@leverege/i18n';
const {
  t,
  tIcon
} = I18N.ns('molten.mapDataViewer.google.Clustering');
const CLUSTER_LAYER_TYPES = new Set(['molten.googleMapRenderer.GeohashGridModel', 'molten.googleMapRenderer.GroupClusterModel']);
export default {
  id: 'molten.mapDataViewer.google.Clustering',
  matches: {
    client: 'GoogleMapsDataViewer',
    use: 'bottomRightActionBar'
  },
  layout: {
    sort: 'set'
  },
  handles: context => {
    const {
      clientProps: {
        settings
      }
    } = context;
    return settings?.layers.some(layer => {
      return CLUSTER_LAYER_TYPES.has(layer.type) && layer.visible;
    });
  },
  appearance: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    const {
      overrideModel
    } = clientProps;
    const checked = overrideModel?.shouldCluster == null || overrideModel.shouldCluster === true;
    return {
      name: t('name'),
      prefer: 'icon',
      checkStyle: 'toggle',
      checked,
      icon: tIcon('icon')
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    const {
      overrides,
      overrideModel,
      dataViewerId
    } = clientProps;
    if (overrideModel == null || overrideModel.shouldCluster == null || overrideModel.shouldCluster === true) {
      overrides.set(dataViewerId, 'shouldCluster', false);
    } else {
      overrides.set(dataViewerId, 'shouldCluster', true);
    }
  }
};